<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h5 class="vue-title">
          <strong>{{ $t("STOREMANAGEMENT") }} ＞ {{ $t(this.FormTitle) }}</strong>
        </h5>
      
        <b-form class="formTextSize" @submit.prevent="submitData">
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("STORENAME") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="name"
                  v-model.trim="$v.createStore.name.$model"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors
                  :control="$v.createStore.name"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="4">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("POSTALCODE") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="postal_code"
                   @keypress="isNumberValidatorPost($event)"
                   @blur="checkPostalCode"
                  @keydown="removeDash($event)"
                  v-model.trim="$v.createStore.postal_code.$model"
                  class="inputField"
                  type="tel"
                  autocomplete="name"
                  :maxlength="CONSTANTS.postalCode"
                ></b-form-input>
                <show-errors
                  :control="$v.createStore.postal_code"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12" md="4">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("PREFECTURES") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="prefecture"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  v-model.trim="$v.createStore.prefecture.$model"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors
                  :control="$v.createStore.prefecture"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12" md="4">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("CITY") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="city"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  v-model.trim="$v.createStore.city.$model"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors
                  :control="$v.createStore.city"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("STREETADDRESS") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="street_address"
                  v-model.trim="$v.createStore.street_address.$model"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors
                  :control="$v.createStore.street_address"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>{{ $t("BUILDINGNAME") }}</span>
                <b-form-input
                  id="building_name"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  v-model.trim="$v.createStore.building_name.$model"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors
                  :control="$v.createStore.building_name"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="12" md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("MOBILE") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="contact_no"
                  @keypress="isNumberValidatorphone($event)"
                  v-model.trim="$v.createStore.contact_no.$model"
                  class="inputField"
                  type="tel"
                  autocomplete="off"
                  :maxlength="CONSTANTS.MaxPhone"
                ></b-form-input>
                <show-errors
                  :control="$v.createStore.contact_no"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("EMAIL") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="email"
                  v-model.trim="$v.createStore.email.$model"
                  class="inputField"
                  type="text"
                  @keypress="preventSpecialChar($event)"
                  autocomplete="name"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors
                  :control="$v.createStore.email"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>

            <b-col sm="12" md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("PERSONINCHARGE") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="person_in_charge"
                  v-model.trim="$v.createStore.person_in_charge.$model"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors
                  :control="$v.createStore.person_in_charge"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("CONTACTNAME") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  id="email"
                  v-model.trim="$v.createStore.contact_name.$model"
                  class="inputField"
                  type="text"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors
                  :control="$v.createStore.contact_name"
                  :field="$t('MANDATORY')"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row></b-row>
          <b-row>
            <b-col
              md="6"
              v-for="(item, index) in selectedCustomList"
              :key="index"
            >
              <b-form-group
                id="addressField"
                :label="item.name"
                label-for="input-1"
              >
                <b-form-input
                  class="inputField"
                  :type="item.type"
                  autocomplete="name"
                  v-model="selectedCustomList[index].text"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <br />
          <b-row>
            <b-col sm="12" class="text-center">
              <b-button
                class="btn btn-secondary formTextSizeBlack mr-2"
                to="/storemanagement"
                >{{ $t("CANCEL") }}</b-button
              >
              <button class="btn btn-primary formTextSizeBlack" type="submit">
                {{ $t("ADDTO") }}
              </button>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
   
  </div>
</template>

<script>
import {
  CREATE_PARTNER_STORE,
  EDIT_PARTNER_STORE,
  GET_PARTNER_STORE
} from "@/store/actions.type";
import * as _ from "lodash";
import {
  required,
  email,
  minLength,
} from "vuelidate/lib/validators";
import ShowErrors from "@/components/ShowErrors";
import {
  isNumberValidator,
  preventSpecialChar,
  isNumberValidatorphone,
  phoneDigitValidation
} from "@/shared/utils.js";
import { CONSTANTS } from "@/shared/utils";

export default {
  name: "add-partner",
  components: {
    ShowErrors
  },

  data: function() {
    return {
      FormTitle: "CREATE",
      preventSpecialChar: preventSpecialChar,
      isNumberValidator: isNumberValidator,
      isNumberValidatorphone: isNumberValidatorphone,
      phoneDigitValidation: phoneDigitValidation,

      params: {},
      CONSTANTS: CONSTANTS,
      createStore: {
        person_in_charge: "",
        name: "",
        street_address: "",
        contact_no: "",
        email: "",
        prefecture: "",
        building_name: "",
        city: "",
        postal_code: "",
        contact_name: "",
        userid: ""
      }
    };
  },
  /*validation for the Each fields in From */
  validations: {
    createStore: {
      name: { required },
      person_in_charge: { required },
      street_address: { required },
 contact_no: { required, phoneNumber: minLength(10) },
       email: { required, email },
      prefecture: {},
      building_name: {},
      city: {},
      postal_code: { required, postalCode: minLength(8) },
      contact_name: { required }
    }
  },
  methods: {
     
    /* Remove digit when user removing dash */
    removeDash(evt) {
      if (this.createStore.postal_code.length == 4) {
        this.createStore.postal_code = this.createStore.postal_code.substring(
          0,
          this.createStore.postal_code.length - 1
        );
      }
    },
    /*Postal code validating. Adding - after */
    isNumberValidatorPost(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) 
      ) {
        evt.preventDefault();
      }
      if (this.createStore.postal_code.length == 3) {
        this.createStore.postal_code = this.createStore.postal_code + "-";
      }else if (this.createStore.postal_code.length < 3) {
        this.createStore.postal_code =  this.createStore.postal_code.replace("-", "");
      }
     
    },
    /* On focus out do postal code format */
    checkPostalCode() {
      let temp = this.createStore.postal_code.replace("-", "");
      if (temp.length > 3) {
        let startString = temp.slice(0, 3);
        let endString = temp.slice(3, 7);
        this.createStore.postal_code = startString + "-" + endString;
      }
    },
    /*Submiting the Filled Form Input: the Filled Form Output: boolean return  */
    submitData(evt) {
       if(phoneDigitValidation(this.createStore.contact_no) === true){
       this.$toast.error({
         message: this.$t("INVALIDPHONENO")
          });
      }
      else{
      this.$toast.removeAll();
      this.$v.$touch();
      if (!this.$v.createStore.$invalid) {
        let paylod = this.createStore;
        this.isLoading = this.$loading.show({
          loader: "dots",
          color: "#007bff"
        });
        if (_.get(this.params, "id", 0)) {
          paylod["id"] = this.params.id;
          this.$store.dispatch(EDIT_PARTNER_STORE, paylod).then(data => {
            this.isLoading.hide();
            if (data.status) {
              this.$toast.success({
                message: data.message
              });
              this.$router.push({
                name: "storemanagement"
              });
            } else {
              this.$toast.error({
                message: data.message
              });
            }
          });
        } else {
          this.$store.dispatch(CREATE_PARTNER_STORE, paylod).then(data => {
            this.isLoading.hide();
            if (data.status) {
              this.$toast.success({
                message: data.message
              });
              this.$router.push({
                name: "storemanagement"
              });
            } else {
              this.$toast.error({
                message: data.message
              });
            }
          });
        }
      }
      }
    },
    pickAs(obj, props) {
      let temp = {};
      let data = Object.entries(props).reduce((r, [k, v]) => {
        if (k in props) temp[k] = _.get(obj, v, "");
        return temp;
      }, {});
      return data;
    }
  },
  created() {
    this.params = this.$route.params;
    if (_.get(this.params, "id", 0)) {
      this.FormTitle = "EDIT";
      this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });

      this.$store
        .dispatch(GET_PARTNER_STORE, {
          id: _.get(this.params, "id", 0)
        })
        .then(data => {
          this.isLoading.hide();
          if (_.get(data, "status", 0)) {
            this.createStore = this.pickAs(data.partner, {
              building_name: "address.building_name",
              postal_code: "address.postal_code",
              street_address: "address.street_address",
              prefecture: "address.prefecture",
              name: "name",
              contact_no: "contact_no",
              email: "email",
              city: "address.city",
              contact_name: "partner_staff_detail.first_name",
              person_in_charge: "partner_staff_detail.last_name"
            });
          }
        });
    }
  }
};
</script>
